import { SyntheticEvent, useEffect, useRef } from 'react'
import styled from 'styled-components'
import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'
import { ModalType } from 'src/types/types'
import DefaultModal from 'src/components/atomic/Molecules/Modal/DefaultModal'
import DeleteDataModal from 'src/components/atomic/Molecules/Modal/DeleteDataModal'
import WifiListModal from 'src/components/atomic/Molecules/Modal/WifiListModal'
import UnLockDeviceModal from 'src/components/atomic/Molecules/Modal/UnLockDeviceModal'
import BackupDataModal from 'src/components/atomic/Molecules/Modal/BackupDataModal'
import { useLockBodyScrollHook } from 'src/hooks/useLockBodyScroll.hook'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import { RootState } from 'src/store/store'
import { COLOR } from 'src/constants/colors'
import { useLocation } from 'react-router-dom'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
import { setCloseModal } from 'src/store/Reducer/common/modalSlice'

const Modal = () => {
  const { type, isOpen } = useAppSelector((state: RootState) => state.modal)
  const { currentMedia } = useMediaQueryHook()
  const dispatch = useAppDispatch()
  const { pathname } = useLocation()
  const modalRef = useRef<HTMLDivElement>(null)
  useLockBodyScrollHook(isOpen)
  const InnerComponent = (type: ModalType) => {
    switch (type) {
      case 'wifiList':
        return <WifiListModal />
      case 'unLockDevice':
        return <UnLockDeviceModal />
      case 'deleteData':
        return <DeleteDataModal />
      case 'backupData':
        return <BackupDataModal />
      default:
        // 'alert,'confirm',
        return <DefaultModal />
    }
  }

  // 버튼을 클릭해서 모달이 노출 되는 경우 이전 버튼에서의 포커스가 풀리지 않아
  // 스페이스바, 엔터 등으로 버튼 submit이 계속일어나는 이슈를 해야하기 위한 곳
  useEffect(() => {
    isOpen && modalRef.current !== null && modalRef.current.focus()
  }, [isOpen])

  useEffect(() => {
    dispatch(setCloseModal())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  return (
    <ModalWrap $isOpen={`${isOpen}`} ref={modalRef} tabIndex={0}>
      <ModalBox media={currentMedia} onClick={(e: SyntheticEvent) => e.stopPropagation()}>
        {InnerComponent(type)}
      </ModalBox>
    </ModalWrap>
  )
}
export default Modal

const ModalWrap = styled.div<{ $isOpen: string }>`
  z-index: 9997;
  width: 100%;
  height: 1000vh;
  position: absolute;
  top: 0;
  left: 0;
  justify-content: center;
  align-items: center;
  background: ${COLOR.blackOpacity07};
  display: ${(props) => (props.$isOpen === 'true' ? 'flex' : 'none')};
`

const ModalBox = styled.div<{ media?: string }>`
  display: block;
  position: fixed;
  background: ${COLOR.white};
  max-width: 400px;
  width: calc(100% - 40px);
  height: auto;
  margin: 0 auto;
  border-radius: 16px;
  text-align: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 32px;
`
